import { DateTimeInput, FormTab, RadioButtonGroupInput, TextInput } from 'react-admin';

import CraftEdit from 'src/components/CraftEdit';
import CraftTabbedForm from 'src/components/CraftTabbedForm';
import { CraftPageSection } from 'src/components/CraftPageSection';
import { JsonInput } from 'src/inputs/JsonInput';
import { Typography } from '@mui/material';
import { SignalsEditAside } from './EditAside';
import { ALERT_POLARITIES, ALERT_SEVERITIES } from '../publishedAlerts/PublishedAlertsTypes';

export const SignalsEdit = () => (
  <CraftEdit header="Signal" redirect={false} mutationMode="pessimistic" aside={<SignalsEditAside />}>
    <CraftTabbedForm
      formType="edit"
      deleteOptions={{
        deletePermission: 'alerts:delete',
      }}
    >
      <FormTab label="Details">
        <CraftPageSection title="Details">
          <TextInput source="id" disabled />
          <TextInput source="signal_title" />
          <TextInput source="signal_text" multiline />
          <TextInput source="source_url" multiline />
          <DateTimeInput source="date" helperText="Should indicate when the event occured" />
        </CraftPageSection>
        <CraftPageSection title="Classification">
          <TextInput source="dataset" label="Dataset" />
          <TextInput source="signal_class" label="Class" />
          <RadioButtonGroupInput source="signal_polarity" choices={ALERT_POLARITIES} />
          <RadioButtonGroupInput source="signal_severity" choices={ALERT_SEVERITIES} />
        </CraftPageSection>
        <CraftPageSection title="Entities">
          <TextInput source="company_id" label="Company ID" />
          <TextInput source="resource_id" label="Resource ID" />
        </CraftPageSection>
      </FormTab>
      <FormTab label="Payload">
        <CraftPageSection title="Payload">
          <Typography variant="caption">
            Certain types of payloads are validated by the Signals Validation Service. See this{' '}
            <a href="https://github.com/craft-machine/signals-validation-service/tree/main/schemas">source</a> for more
            details.
          </Typography>
          <JsonInput source="payload" label=" " />
        </CraftPageSection>
      </FormTab>
    </CraftTabbedForm>
  </CraftEdit>
);
